export default __webpack_public_path__ + "static/media/speech_therapy.6a250621.png";